"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteUrlStatus = exports.FavoriteUrlOperator = exports.CSSConditionOperator = exports.CSSSelectorType = exports.DatalayerConditionOperator = exports.FavoriteUrlFieldNamesEnum = void 0;
var FavoriteUrlFieldNamesEnum;
(function (FavoriteUrlFieldNamesEnum) {
    FavoriteUrlFieldNamesEnum["name"] = "name";
    FavoriteUrlFieldNamesEnum["conditions"] = "conditions";
    FavoriteUrlFieldNamesEnum["all_positive_conditions"] = "all_positive_conditions";
    FavoriteUrlFieldNamesEnum["all_negative_conditions"] = "all_negative_conditions";
    FavoriteUrlFieldNamesEnum["css_selector_conditions"] = "css_selector_conditions";
    FavoriteUrlFieldNamesEnum["css_selector_displayed"] = "css_selector_displayed";
    FavoriteUrlFieldNamesEnum["all_css_conditions"] = "all_css_conditions";
    FavoriteUrlFieldNamesEnum["css_code"] = "css_code";
    FavoriteUrlFieldNamesEnum["datalayer_conditions"] = "datalayer_conditions";
    FavoriteUrlFieldNamesEnum["datalayer_mode"] = "datalayer_mode";
    FavoriteUrlFieldNamesEnum["all_datalayer_conditions"] = "all_datalayer_conditions";
    FavoriteUrlFieldNamesEnum["datalayer_latency_value"] = "datalayer_latency_value";
})(FavoriteUrlFieldNamesEnum = exports.FavoriteUrlFieldNamesEnum || (exports.FavoriteUrlFieldNamesEnum = {}));
var DatalayerConditionOperator;
(function (DatalayerConditionOperator) {
    DatalayerConditionOperator["contains"] = "contains";
    DatalayerConditionOperator["equal"] = "equal";
    DatalayerConditionOperator["greater"] = "greater";
    DatalayerConditionOperator["lower"] = "lower";
    DatalayerConditionOperator["between"] = "between";
    DatalayerConditionOperator["declared"] = "declared";
    DatalayerConditionOperator["regex"] = "regex";
})(DatalayerConditionOperator = exports.DatalayerConditionOperator || (exports.DatalayerConditionOperator = {}));
var CSSSelectorType;
(function (CSSSelectorType) {
    CSSSelectorType["id"] = "id";
    CSSSelectorType["class"] = "class";
    CSSSelectorType["element"] = "element";
})(CSSSelectorType = exports.CSSSelectorType || (exports.CSSSelectorType = {}));
var CSSConditionOperator;
(function (CSSConditionOperator) {
    CSSConditionOperator["is"] = "is";
    CSSConditionOperator["is_not"] = "is not";
})(CSSConditionOperator = exports.CSSConditionOperator || (exports.CSSConditionOperator = {}));
var FavoriteUrlOperator;
(function (FavoriteUrlOperator) {
    FavoriteUrlOperator["is"] = "is";
    FavoriteUrlOperator["contain"] = "contain";
    FavoriteUrlOperator["regex"] = "regex";
    FavoriteUrlOperator["is strictly"] = "is strictly";
})(FavoriteUrlOperator = exports.FavoriteUrlOperator || (exports.FavoriteUrlOperator = {}));
var FavoriteUrlStatus;
(function (FavoriteUrlStatus) {
    FavoriteUrlStatus["active"] = "active";
    FavoriteUrlStatus["inactive"] = "inactive";
})(FavoriteUrlStatus = exports.FavoriteUrlStatus || (exports.FavoriteUrlStatus = {}));
//# sourceMappingURL=types.js.map